import React from "react";
import slider_two from "../Pages/images/slide_two.png";
import slider_three from "../Pages/images/slide_three.png";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import "./imageSlider.css";


function ImageSlider() {
  return (
    <>
      <Carousel className="imageSlider">
        <Carousel.Item interval={3000}>
          <img
            className="w-100"
            src={slider_two}
            alt="Second slide"
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </Carousel.Item>
        <Carousel.Item interval={3000}>
          <img
            className="w-100"
            src={slider_three}
            alt="Third slide"
            loading="lazy"
            decoding="async"
          />
        </Carousel.Item>
      </Carousel>
    </>
  );
}

export default ImageSlider;
